/**
 * Append company_id so agent / Sources APIs bind to the console account picker.
 * One agent process per host; RBAC decides which projects a person may open.
 */
export function withAgentCompanyQuery(
  path: string,
  companyId?: number | null,
): string {
  const id = Number(companyId);
  if (!Number.isFinite(id) || id <= 0) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}company_id=${encodeURIComponent(String(id))}`;
}
